import * as Yup from 'yup';

export const schema = Yup.object().shape({
  license_plate: Yup.string().required(),
  mall: Yup.string().required(),
  motive: Yup.string().required(),
  description: Yup.string().required(),
  date_ini: Yup.date().required(),
  date_end: Yup.date().required()
});

export const formInitialState = {
  license_plate: '',
  mall: '',
  country_id: '',
  motive: '',
  description: '',
  date_ini: new Date(),
  date_end: new Date()
};

export const formErrorInitialState = {
  license_plateError: false,
  mallError: false,
  motiveError: false,
  descriptionError: false,
  date_iniError: false,
  date_endError: false
};
